export class RoleList {
  key: string;
  value: boolean;
  label: string;

  constructor(label: string, key: string, value: boolean) {
    this.key = key;
    this.value = value;
    this.label = label;
  }

}
